module.exports = __webpack_public_path__ + "img/litigant.bd06c34d.svg";